import axios from "axios";
import { API_BASE as API } from "./base";

const authHeaders = (token) => ({
  Authorization: `Bearer ${token || ""}`,
  "Content-Type": "application/json",
});

const authOnlyHeaders = (token) => ({
  Authorization: `Bearer ${token || ""}`,
});

const errorMessage = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail) {
    return detail;
  }
  if (detail && typeof detail === "object" && detail.message) {
    return detail.message;
  }
  return err?.message || fallback;
};

export async function getMyProfile(token) {
  try {
    const res = await axios.get(`${API}/users/me/profile`, {
      headers: authHeaders(token),
    });
    return res.data;
  } catch (err) {
    throw new Error(errorMessage(err, "Unable to load your profile."));
  }
}

export async function getMyKpiProgress(token) {
  try {
    const res = await axios.get(`${API}/users/me/kpi-progress`, {
      headers: authHeaders(token),
    });
    return res.data;
  } catch (err) {
    throw new Error(errorMessage(err, "Unable to load KPI progress."));
  }
}

export async function updateMyProfile(payload, token) {
  try {
    const res = await axios.put(`${API}/users/me/profile`, payload, {
      headers: authHeaders(token),
    });
    return res.data;
  } catch (err) {
    throw new Error(errorMessage(err, "Unable to save your profile."));
  }
}

export async function uploadMyProfilePhoto(file, token) {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const res = await axios.post(`${API}/users/me/profile/photo`, formData, {
      headers: authOnlyHeaders(token),
    });
    return res.data;
  } catch (err) {
    throw new Error(errorMessage(err, "Unable to upload your profile photo."));
  }
}

export async function removeMyProfilePhoto(token) {
  try {
    const res = await axios.delete(`${API}/users/me/profile/photo`, {
      headers: authOnlyHeaders(token),
    });
    return res.data;
  } catch (err) {
    throw new Error(errorMessage(err, "Unable to remove your profile photo."));
  }
}

export async function changeMyPassword(payload, token) {
  try {
    const res = await axios.post(`${API}/auth/change-password`, payload, {
      headers: authHeaders(token),
    });
    return res.data;
  } catch (err) {
    throw new Error(errorMessage(err, "Could not change password."));
  }
}
